import Trademark from 'components/Generics/Trademark/Trademark';
import React from 'react';
import * as S from './Footer.style';

const Footer = (): React.ReactElement => {
    return (
        <S.Footer>
            <Trademark />
        </S.Footer>
    );
};

export default Footer;